import { h, Fragment } from 'preact'
import PropTypes from 'prop-types'
import { SelectIcon } from '../../../assets/dynamicIcons/SelectIcon'
import { useTranslations } from '../../../hooks/useTranslations'

const GroupSelectBox = ({
  label,
  selectProps,
  options = {},
  testIdForOptions = 'group-select-box-option',
  className,
}) => {
  const l10n = useTranslations()

  return (
    <label
      className={`input input-select ${className}`}
      data-testid="group-select-box-label"
    >
      <div className="label">{label}</div>
      <div className="group">
        <select {...selectProps}>
          {Object.keys(options).map(item => (
            <>
              <option value=""></option>
              <optgroup label={item}>
                {options[item].map(option => (
                  <option value={option} data-testid={testIdForOptions}>
                    {option}
                  </option>
                ))}
              </optgroup>
            </>
          ))}
        </select>
        <label
          aria-label={`${l10n.t('Control for: ')} ${label}`}
          className="icon-control"
          htmlFor={selectProps.id}
        >
          <SelectIcon/>
        </label>
      </div>
    </label>
  )
}

GroupSelectBox.propTypes = {
  label: PropTypes.string.isRequired,
  className: PropTypes.string,
  selectProps: PropTypes.object.isRequired,
  options: PropTypes.object.isRequired,
  testIdForOptions: PropTypes.string,
}

export default GroupSelectBox
